module.exports = __webpack_public_path__ + "img/checkedIcon.eea79231.svg";